import React, { useEffect, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useController, useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CustomInput({
  control,
  name,
  rules,
  defaultValue = '',
  icon = null,
  formLabel = '',
  placeHolder = '',
  typeInput = 'text',
  classNames = { input: 'text-uppercase' },
  disabled = false,
  clearCaracter = false,
  minLength = 5,
  maxLength = 60,
  regexClear = 'D',
  regexWordsClear = '\\bundefined\\b',
  transformText = 'uppercase',
}) {
  // Integracion con React Hook Form
  const {
    field: { onChange, onBlur },
    fieldState: { error },
    // setValue,
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });
  const { setValue } = useFormContext();
  const inputRef = useRef();

  // Funcion para manejar el cambio del valor
  const handleOnChange = (value) => {
    onChange(value); // Actualiza el valor en React Hook Form
  };

  const handleOnInput = (event) => {
    // Remueve cualquier caracter que no sea numero
    if (clearCaracter) {
      const regex = new RegExp(regexClear, 'g');
      const regexWordClear = new RegExp(regexWordsClear, 'gmi');
      // console.log(event.target.value, regex)
      // eslint-disable-next-line no-param-reassign
      event.target.value = event.target.value.replace(regex, '');
      // eslint-disable-next-line no-param-reassign
      event.target.value = event.target.value.replace(regexWordClear, '');
      if (transformText === 'uppercase') {
        // eslint-disable-next-line no-param-reassign
        event.target.value = event.target.value.toUpperCase();
      }
    }

    // Remueve cualquier caracter que no sea numero
    // if (clearCaracter) {
    //   // eslint-disable-next-line no-param-reassign
    //   event.target.value = event.target.value.replace(/\D/g, '');
    // }

    return event.target.value;
  };

  // Funcion para manejar el focus del input
  // const handleOnBlur = (option) => {
  //   console.log(option)
  // };

  // const handleKeyDown = (e) => {
  //   console.log(e.key, e.target)
  //   if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
  //     // El usuario presionó Ctrl+A, podrías mostrar una advertencia
  //     alert('El usuario presionó Ctrl+A, podrías mostrar una advertencia');
  //   }
  //   if (e.key === 'Delete' && e.target.selectionStart !== e.target.selectionEnd) {
  //     // El usuario está borrando una selección
  //     alert('El usuario está borrando una selección')
  //   }
  // };

  useEffect(() => {
    const input = inputRef.current;
    const handleInput = (e) => {
      if (e.inputType === 'deleteContentBackward' && e.target.value === '') {
        console.log('Usuario borró todo el contenido');
        setValue(name, '', {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    };

    input.addEventListener('input', handleInput);
    return () => input.removeEventListener('input', handleInput);
  }, [name, setValue]);

  return (
    <div className="custom-input position-relative w-100">
      <Card className={`${classNames?.card} ${error ? 'invalid-input-border' : ''}`}>
        <Card.Body className={`${classNames?.cardBody}`}>
          <div className="d-flex">
            {icon && (
              <div className="checking__group-icon pe-2 d-flex align-items-center">
                <FontAwesomeIcon icon={icon} size="2x" className="app-txt-gray" />
              </div>
            )}

            <Form.Group className="flex-fill" controlId={`control-${name}`}>
              {formLabel && (
                <Form.Label
                  className={`mb-0 ${classNames?.label}`}
                >
                  {formLabel}
                </Form.Label>
              )}
              <Form.Control
                minLength={minLength}
                maxLength={maxLength}
                ref={inputRef}
                disabled={disabled}
                onChange={handleOnChange}
                // onBlur={handleOnBlur}
                // onKeyDown={handleKeyDown}
                // onSelect={(e) => {
                //   const selection = e.target.value.substring(
                //     e.target.selectionStart,
                //     e.target.selectionEnd
                //   );
                //   if (selection === e.target.value) {
                //     console.log('Usuario seleccionó todo el texto');
                //   }
                // }}
                name={name}
                defaultValue={defaultValue}
                className={`w-100 border-0 ps-0 shadow-none py-0 ${classNames?.input}`}
                type={typeInput}
                placeholder={placeHolder}
                onInput={handleOnInput}
              />
              {/* <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text> */}
            </Form.Group>
          </div>
        </Card.Body>
      </Card>

      {/* Mostrar mensaje de error */}
      {/* {error && <span className="error-message">{error.message}</span>} */}
    </div>
  );
}

export default CustomInput;
